(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cure-home-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-cure-hero]').forEach((root) => {
      if (root.dataset.cureHeroReady === 'true') return;
      root.dataset.cureHeroReady = 'true';

      const slides = Array.from(root.querySelectorAll('[data-cure-hero-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-cure-hero-dot]'));
      if (slides.length < 2) return;

      let index = 0;

      const sync = () => {
        slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
      };

      root.querySelector('[data-cure-hero-prev]')?.addEventListener('click', () => {
        index = (index - 1 + slides.length) % slides.length;
        sync();
      });

      root.querySelector('[data-cure-hero-next]')?.addEventListener('click', () => {
        index = (index + 1) % slides.length;
        sync();
      });

      dots.forEach((dot, dotIndex) => {
        dot.addEventListener('click', () => {
          index = dotIndex;
          sync();
        });
      });

      window.setInterval(() => {
        index = (index + 1) % slides.length;
        sync();
      }, 6500);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cure-home-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const parseSectionData = (panel) => {
      const source = panel.querySelector('[data-cure-showcase-data]');
      if (!source) return null;

      try {
        return JSON.parse(source.textContent);
      } catch (error) {
        console.error('Failed to parse Cure showcase data', error);
        return null;
      }
    };

    const renderVariantControls = (panel, product, selectedVariantId, onSelectVariant) => {
      const buttonContainer = panel.querySelector('[data-cure-showcase-sizes]');
      const select = panel.querySelector('[data-cure-showcase-size-select]');

      if (buttonContainer) {
        buttonContainer.innerHTML = '';

        product.variants.forEach((variant) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'cure-showcase__size-button';
          button.dataset.cureShowcaseSize = '';
          button.dataset.variantId = String(variant.id);
          button.textContent = variant.title;
          button.setAttribute('aria-pressed', String(String(variant.id) === String(selectedVariantId)));

          if (String(variant.id) === String(selectedVariantId)) {
            button.classList.add('is-active');
          }

          button.addEventListener('click', () => onSelectVariant(variant.id));
          buttonContainer.appendChild(button);
        });
      }

      if (select) {
        select.innerHTML = '';

        product.variants.forEach((variant) => {
          const option = document.createElement('option');
          option.value = String(variant.id);
          option.textContent = variant.title;
          select.appendChild(option);
        });

        select.value = String(selectedVariantId || product.variants[0]?.id || '');
        select.onchange = () => {
          if (select.value) onSelectVariant(select.value);
        };
      }
    };

    const syncPanel = (panel) => {
      const data = parseSectionData(panel);
      if (!data?.products?.length) return;

      const productsByHandle = new Map(data.products.map((product) => [product.handle, product]));
      let activeHandle = productsByHandle.has(panel.dataset.initialHandle) ? panel.dataset.initialHandle : data.initialHandle;
      if (!productsByHandle.has(activeHandle)) {
        activeHandle = data.products[0].handle;
      }

      let activeVariantId = null;
      let quantity = 1;

      const flavorButtons = Array.from(panel.querySelectorAll('[data-cure-showcase-flavor]'));
      const drinkImage = panel.querySelector('[data-cure-showcase-drink]');
      const packImage = panel.querySelector('[data-cure-showcase-pack]');
      const subscribePrice = panel.querySelector('[data-cure-showcase-subscribe-price]');
      const oneTimePrice = panel.querySelector('[data-cure-showcase-one-time-price]');
      const qtyValue = panel.querySelector('[data-cure-showcase-qty-value]');
      const qtyInput = panel.querySelector('[data-cure-showcase-quantity-input]');
      const ctaText = panel.querySelector('[data-cure-showcase-cta-text]');
      const detailsLink = panel.querySelector('[data-cure-showcase-details]');
      const formComponent = panel.querySelector('product-form-component');
      const variantIdInput = panel.querySelector('input[name="id"]');
      const addToCartContainer = panel.querySelector('add-to-cart-component');
      const addToCartButton = panel.querySelector('[ref="addToCartButton"]');

      const setQuantity = (nextQuantity) => {
        quantity = Math.max(1, nextQuantity);
        if (qtyValue) qtyValue.textContent = String(quantity);
        if (qtyInput) qtyInput.value = String(quantity);
      };

      const setVariant = (product, variantId) => {
        const ctaLabel = panel.dataset.ctaLabel || 'Add';
        const soldOutLabel = panel.dataset.soldOutLabel || 'Sold out';
        const variant = product.variants.find((item) => String(item.id) === String(variantId)) || product.variants[0];
        activeVariantId = variant ? variant.id : null;

        if (!variant) return;

        if (subscribePrice) subscribePrice.textContent = variant.subscribePriceText || '';
        if (oneTimePrice) oneTimePrice.textContent = variant.priceText || '';

        if (variantIdInput) {
          variantIdInput.value = String(variant.id);
          variantIdInput.disabled = !variant.available;
        }

        if (addToCartButton) {
          addToCartButton.disabled = !variant.available;
        }

        if (ctaText) {
          ctaText.textContent = variant.available
            ? `${ctaLabel.toUpperCase()} · ${variant.priceText}`
            : soldOutLabel;
        }

        renderVariantControls(panel, product, variant.id, (nextVariantId) => setVariant(product, nextVariantId));
      };

      const setProduct = (handle) => {
        const product = productsByHandle.get(handle);
        if (!product) return;

        activeHandle = product.handle;
        flavorButtons.forEach((button) => {
          const isActive = button.dataset.handle === product.handle;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });

        if (drinkImage) {
          drinkImage.src = product.mainImage.src;
          drinkImage.alt = product.mainImage.alt || product.title;
        }

        if (packImage) {
          packImage.src = product.packImage.src;
          packImage.alt = product.packImage.alt || product.title;
        }

        if (detailsLink) {
          detailsLink.href = product.url;
        }

        if (formComponent) {
          formComponent.dataset.productId = String(product.id);
        }

        if (addToCartContainer && (product.packImage.src || product.mainImage.src)) {
          addToCartContainer.dataset.productVariantMedia = product.packImage.src || product.mainImage.src;
        }

        setVariant(product, activeVariantId && product.variants.some((variant) => String(variant.id) === String(activeVariantId)) ? activeVariantId : product.variants[0]?.id);
      };

      flavorButtons.forEach((button) => {
        button.addEventListener('click', () => {
          setProduct(button.dataset.handle);
        });
      });

      panel.querySelectorAll('[data-cure-showcase-qty-step]').forEach((button) => {
        button.addEventListener('click', () => {
          const delta = Number(button.dataset.cureShowcaseQtyStep || '0');
          setQuantity(quantity + delta);
        });
      });

      setQuantity(1);
      setProduct(activeHandle);
    };

    document.querySelectorAll('[data-cure-showcase]').forEach((root) => {
      if (root.dataset.cureShowcaseReady === 'true') return;
      root.dataset.cureShowcaseReady = 'true';

      const tabs = Array.from(root.querySelectorAll('[data-cure-showcase-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-cure-showcase-panel]'));
      if (!tabs.length || tabs.length !== panels.length) return;

      const syncTabs = (index) => {
        tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === index;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
        });
        panels.forEach((panel, panelIndex) => panel.classList.toggle('is-active', panelIndex === index));
      };

      panels.forEach((panel) => syncPanel(panel));

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => syncTabs(index));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cure-site-header-refresh"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-cure-header]').forEach((root) => {
      if (root.dataset.cureHeaderReady === 'true') return;
      root.dataset.cureHeaderReady = 'true';

      const slides = Array.from(root.querySelectorAll('.cure-header__announcement-slide'));
      const drawer = root.querySelector('[data-cure-drawer]');
      const searchDialog = root.querySelector('[data-cure-search-dialog]');
      let activeIndex = 0;

      if (slides.length > 1 && root.querySelector('[data-cure-announcement-track]')) {
        window.setInterval(() => {
          slides[activeIndex].classList.remove('is-active');
          activeIndex = (activeIndex + 1) % slides.length;
          slides[activeIndex].classList.add('is-active');
        }, 5000);
      }

      root.querySelectorAll('[data-cure-drawer-open]').forEach((button) => {
        button.addEventListener('click', () => {
          drawer?.classList.add('is-open');
          document.documentElement.style.overflow = 'hidden';
        });
      });

      root.querySelectorAll('[data-cure-drawer-close]').forEach((button) => {
        button.addEventListener('click', () => {
          drawer?.classList.remove('is-open');
          document.documentElement.style.overflow = '';
        });
      });

      root.querySelectorAll('[data-cure-search-open]').forEach((button) => {
        button.addEventListener('click', () => {
          drawer?.classList.remove('is-open');
          document.documentElement.style.overflow = '';
          if (searchDialog?.showModal) {
            searchDialog.showModal();
          }
        });
      });

      root.querySelectorAll('[data-cure-search-close]').forEach((button) => {
        button.addEventListener('click', () => searchDialog?.close());
      });

      searchDialog?.addEventListener('click', (event) => {
        const rect = searchDialog.getBoundingClientRect();
        const inside =
          event.clientX >= rect.left &&
          event.clientX <= rect.right &&
          event.clientY >= rect.top &&
          event.clientY <= rect.bottom;

        if (!inside) searchDialog.close();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cure-site-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-cure-header]').forEach((root) => {
      if (root.dataset.cureHeaderReady === 'true') return;
      root.dataset.cureHeaderReady = 'true';

      const slides = Array.from(root.querySelectorAll('.cure-header__announcement-slide'));
      const drawer = root.querySelector('[data-cure-drawer]');
      const searchDialog = root.querySelector('[data-cure-search-dialog]');
      let activeIndex = 0;

      if (slides.length > 1 && root.querySelector('[data-cure-announcement-track]')) {
        window.setInterval(() => {
          slides[activeIndex].classList.remove('is-active');
          activeIndex = (activeIndex + 1) % slides.length;
          slides[activeIndex].classList.add('is-active');
        }, 5000);
      }

      root.querySelectorAll('[data-cure-drawer-open]').forEach((button) => {
        button.addEventListener('click', () => {
          drawer?.classList.add('is-open');
          document.documentElement.style.overflow = 'hidden';
        });
      });

      root.querySelectorAll('[data-cure-drawer-close]').forEach((button) => {
        button.addEventListener('click', () => {
          drawer?.classList.remove('is-open');
          document.documentElement.style.overflow = '';
        });
      });

      root.querySelectorAll('[data-cure-search-open]').forEach((button) => {
        button.addEventListener('click', () => {
          drawer?.classList.remove('is-open');
          document.documentElement.style.overflow = '';
          if (searchDialog?.showModal) {
            searchDialog.showModal();
          }
        });
      });

      root.querySelectorAll('[data-cure-search-close]').forEach((button) => {
        button.addEventListener('click', () => searchDialog?.close());
      });

      searchDialog?.addEventListener('click', (event) => {
        const rect = searchDialog.getBoundingClientRect();
        const inside =
          event.clientX >= rect.left &&
          event.clientX <= rect.right &&
          event.clientY >= rect.top &&
          event.clientY <= rect.bottom;

        if (!inside) searchDialog.close();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
